import { CardSkeleton } from "./CardSkeleton";

interface GridSkeletonProps {
  columns?: number;
  rows?: number;
  cardHeight?: string;
}

export const GridSkeleton: React.FC<GridSkeletonProps> = ({
  columns = 2,
  rows = 2,
  cardHeight = "h-32",
}) => (
  <div className={`grid grid-cols-${columns} gap-4`}>
    {Array.from({ length: columns * rows }).map((_, i) => (
      <CardSkeleton key={i} height={cardHeight} animate={false} />
    ))}
  </div>
);